module.exports = ["BannersOracle", "WitchesOracle", "NatureOracleNFTMinter", "WitchesOracleRituals", "HauntedWitches", "BitWitchesRituals"];